/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch reading score`)
};

const es_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación de Flesch`)
};

const de_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch-Lesewert`)
};

const nl_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch-leeswaardering`)
};

const fr_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score de lisibilité Flesch`)
};

const it_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio Flesch`)
};

const pt_br2_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação de leitura Flesch`)
};

const pt_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação Flesch`)
};

const ja_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch読みやすさスコア`)
};

const zh_ra_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch 阅读分数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_nav_main_desc", locale)
	if (locale === "en") return en_ra_nav_main_desc(inputs)
	if (locale === "es") return es_ra_nav_main_desc(inputs)
	if (locale === "de") return de_ra_nav_main_desc(inputs)
	if (locale === "nl") return nl_ra_nav_main_desc(inputs)
	if (locale === "fr") return fr_ra_nav_main_desc(inputs)
	if (locale === "it") return it_ra_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ra_nav_main_desc(inputs)
	if (locale === "pt") return pt_ra_nav_main_desc(inputs)
	if (locale === "ja") return ja_ra_nav_main_desc(inputs)
	return zh_ra_nav_main_desc(inputs)
};